import type { CopilotOverlayStore } from '@/shared/stores/ui';

import type { ICD10CodeT } from '@/entities/labs';
import type { SourceProposedActionT } from '@/shared/lib';
import type { LabTestCollectionMethodT } from '@lotushealth/lotushealth_js_sdk/schemas';

interface LabOrderWizardPrefillBase {
  icdCodes?: ICD10CodeT[];
  notes?: string;
  priority?: boolean;
  sourceProposedAction?: SourceProposedActionT;
}

export interface ExistingLabOrderWizardPrefill extends LabOrderWizardPrefillBase {
  type: 'existing_test';
  labTestId: string;
  labTestName?: string;
}

export interface NativeOrderSetLabOrderWizardPrefill extends LabOrderWizardPrefillBase {
  type: 'native_order_set';
  labSlug: 'quest';
  collectionMethod: LabTestCollectionMethodT;
  labTestIds: string[];
  markerIds: string[];
}

export type LabOrderWizardPrefill =
  | ExistingLabOrderWizardPrefill
  | NativeOrderSetLabOrderWizardPrefill;

declare module '@/shared/stores/ui/copilotOverlay' {
  interface CopilotOverlayPayloads {
    labOrderWizard: LabOrderWizardPrefill | null;
  }
}

/**
 * Open the lab order wizard. Pass ``null`` to open it empty for manual entry,
 * or a prefill to seed it from a proposed action.
 */
export function openLabOrderWizardOverlay(
  overlays: CopilotOverlayStore,
  prefill: LabOrderWizardPrefill | null
): void {
  overlays.open('labOrderWizard', prefill);
}
